import { GUEST, PSTNGUEST } from '@/shared/utils/constants'

export const isGuestIdentity = (value?: string) =>
  Boolean(value && value.includes(GUEST) && !value.includes(PSTNGUEST))
